export enum UserActionType {
  CREATE_FAILURE_CLIENT = '@@user/CREATE_FAILURE_CLIENT',
  CREATE_REQUEST_CLIENT = '@@user/CREATE_REQUEST_CLIENT',

  CREATE_SUCCESS_CLIENT = '@@user/CREATE_SUCCESS_CLIENT',

  CREATE_USER_DEACTIVATIONS_FAILURE = '@@user/CREATE_USER_DEACTIVATIONS_FAILURE',
  CREATE_USER_DEACTIVATIONS_REQUEST = '@@user/CREATE_USER_DEACTIVATIONS_REQUEST',
  CREATE_USER_DEACTIVATIONS_SUCCESS = '@@user/CREATE_USER_DEACTIVATIONS_SUCCESS',

  DELETE_TOKEN_BY_UUID_FAILURE = '@@user/DELETE_TOKEN_BY_UUID_FAILURE',
  DELETE_TOKEN_BY_UUID_REQUEST = '@@user/DELETE_TOKEN_BY_UUID_REQUEST',
  DELETE_TOKEN_BY_UUID_SUCCESS = '@@user/DELETE_TOKEN_BY_UUID_SUCCESS',

  DELETE_USER_DEACTIVATIONS_FAILURE = '@@user/DELETE_USER_DEACTIVATIONS_FAILURE',
  DELETE_USER_DEACTIVATIONS_REQUEST = '@@user/DELETE_USER_DEACTIVATIONS_REQUEST',
  DELETE_USER_DEACTIVATIONS_SUCCESS = '@@user/DELETE_USER_DEACTIVATIONS_SUCCESS',

  GET_ACCESS_ALL_FAILURE = '@@user/GET_ACCESS_ALL_FAILURE',
  GET_ACCESS_ALL_REQUEST = '@@user/GET_ACCESS_ALL_REQUEST',
  GET_ACCESS_ALL_SUCCESS = '@@user/GET_ACCESS_ALL_SUCCESS',

  GET_ACCESS_BY_UUID_FAILURE = '@@user/GET_ACCESS_BY_UUID_FAILURE',
  GET_ACCESS_BY_UUID_REQUEST = '@@user/GET_ACCESS_BY_UUID_REQUEST',
  GET_ACCESS_BY_UUID_SUCCESS = '@@user/GET_ACCESS_BY_UUID_SUCCESS',

  GET_ALL_FAILURE = '@@user/GET_ALL_FAILURE',
  GET_ALL_REQUEST = '@@user/GET_ALL_REQUEST',
  GET_ALL_SUCCESS = '@@user/GET_ALL_SUCCESS',

  GET_ALL_USER_DEACTIVATION_FAILURE = '@@user/GET_ALL_USER_DEACTIVATION_FAILURE',
  GET_ALL_USER_DEACTIVATION_REQUEST = '@@user/GET_ALL_USER_DEACTIVATION_REQUEST',
  GET_ALL_USER_DEACTIVATION_SUCCESS = '@@user/GET_ALL_USER_DEACTIVATION_SUCCESS',

  GET_BILLING_INFO_FAILURE = '@@user/GET_BILLING_INFO_FAILURE',
  GET_BILLING_INFO_REQUEST = '@@user/GET_BILLING_INFO_REQUEST',
  GET_BILLING_INFO_SUCCESS = '@@user/GET_BILLING_INFO_SUCCESS',

  GET_BY_UUID_FAILURE = '@@user/GET_BY_UUID_FAILURE',
  GET_BY_UUID_REQUEST = '@@user/GET_BY_UUID_REQUEST',
  GET_BY_UUID_SUCCESS = '@@user/GET_BY_UUID_SUCCESS',

  GET_RICH_TOKEN_BY_ID_FAILURE = '@@user/GET_RICH_TOKEN_BY_ID_FAILURE',
  GET_RICH_TOKEN_BY_ID_REQUEST = '@@user/GET_RICH_TOKEN_BY_ID_REQUEST',
  GET_RICH_TOKEN_BY_ID_SUCCESS = '@@user/GET_RICH_TOKEN_BY_ID_SUCCESS',

  GET_RICH_TOKEN_BY_UUID_FAILURE = '@@user/GET_RICH_TOKEN_BY_UUID_FAILURE',
  GET_RICH_TOKEN_BY_UUID_REQUEST = '@@user/GET_RICH_TOKEN_BY_UUID_REQUEST',
  GET_RICH_TOKEN_BY_UUID_SUCCESS = '@@user/GET_RICH_TOKEN_BY_UUID_SUCCESS',

  GET_VERIFICATION_FAILURE = '@@user/VERIFICATION_FAILURE',
  GET_VERIFICATION_REQUEST = '@@user/VERIFICATION_REQUEST',
  GET_VERIFICATION_SUCCESS = '@@user/VERIFICATION_SUCCESS',

  PW_RESET_FAILURE = '@@user/PW_RESET_FAILURE',
  PW_RESET_REQUEST = '@@user/PW_RESET_REQUEST',
  PW_RESET_SUCCESS = '@@user/PW_RESET_SUCCESS',

  SEND_DEMAND_USER_CONTACT_US_REQUEST_EMAIL_FAILURE = '@@user/SEND_DEMAND_USER_CONTAC_US_REQUEST_EMAIL_FAILURE',
  SEND_DEMAND_USER_CONTACT_US_REQUEST_EMAIL_REQUEST = '@@user/SEND_DEMAND_USER_CONTAC_US_REQUEST_EMAIL_REQUEST',
  SEND_DEMAND_USER_CONTACT_US_REQUEST_EMAIL_SUCCESS = '@@user/SEND_DEMAND_USER_CONTAC_US_REQUEST_EMAIL_SUCCESS',

  SEND_USER_CREATION_LIMIT_CHANGE_REQUEST_EMAIL_FAILURE = '@@user/SEND_USER_CREATION_LIMIT_CHANGE_REQUEST_EMAIL_FAILURE',
  SEND_USER_CREATION_LIMIT_CHANGE_REQUEST_EMAIL_REQUEST = '@@user/SEND_USER_CREATION_LIMIT_CHANGE_REQUEST_EMAIL_REQUEST',
  SEND_USER_CREATION_LIMIT_CHANGE_REQUEST_EMAIL_SUCCESS = '@@user/SEND_USER_CREATION_LIMIT_CHANGE_REQUEST_EMAIL_SUCCESS',

  SET_CLAIMS = '@@user/SET_CLAIMS',
  SET_PROFILE_META = '@@user/SET_PROFILE_META',

  TOGGLE_CREATE = '@@user/TOGGLE_CREATE',
  TOGGLE_DUPLICATE = '@@user/TOGGLE_DUPLICATE',
  TOGGLE_DUPLICATE_OPEN = '@@user/TOGGLE_DUPLICATE_OPEN',

  UPDATE_FAILURE = '@@user/UPDATE_FAILURE',
  UPDATE_REQUEST = '@@user/UPDATE_REQUEST',
  UPDATE_SUCCESS = '@@user/UPDATE_SUCCESS',
}
